import { useContext } from "react";
import { ValidateContext } from "../context/ValidateContext";

export default function Key({ k, status, onClick }) {

  const buttonIsActive = useContext(ValidateContext);

  let isDisabled;
  // disabled state only for button 'Valider'
  if (k === 'Valider') isDisabled = !buttonIsActive;
  else isDisabled = false;
  
  const getBgColor = () => {
    if (status === "correct") return "#4CAF50";
    if (status === "present") return "#FFC107";
    //if (status === "absent") return "#BDBDBD";
    return "#eee";
  };

  const getTextColor = () => {
    if (status === "absent") return "#bbb";
  };

  return (
    <button
      disabled={isDisabled}
      onClick={() => onClick(k)}
      style={{
        margin: 2,
        padding: "10px 10px",
        fontSize: "18px",
        color: getTextColor(),
        backgroundColor: getBgColor(),
        border: "1px solid #999",
        borderRadius: 6,
        cursor: "pointer"
      }}
    >{k}</button>
  );
}